import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Briefcase, Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { organizationService } from '../../services/api';
import { useTenant } from '../../contexts/TenantContext';
import { userFacingError } from '../../i18n/userFacingError';
import { resolveTenantProfile } from '../../utils/tenantProfile';

export default function SettingsTenantProfileTab({ headerBar }) {
  const { t } = useTranslation('settings');
  const { tenant, patchTenant } = useTenant();
  const [profile, setProfile] = useState('orgao');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let active = true;
    organizationService
      .getPublicChannels()
      .then(({ data }) => {
        if (active) setProfile(resolveTenantProfile(data));
      })
      .catch((error) => {
        if (!active) return;
        setProfile(resolveTenantProfile(tenant));
        toast.error(userFacingError(error, 'settings:tenantProfileLoadError'));
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [tenant]);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await organizationService.updatePublicChannels({ tenant_profile: profile });
      patchTenant?.({ tenant_profile: resolveTenantProfile(data) });
      toast.success(t('tenantProfileSaved'));
    } catch (error) {
      toast.error(userFacingError(error, 'settings:tenantProfileSaveError'));
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="data-list-card flex items-center justify-center gap-2 p-10 text-gray-600">
        <Loader2 className="h-5 w-5 animate-spin" />
        {t('tenantProfileLoading')}
      </div>
    );
  }

  return (
    <div className="data-list-card">
      {headerBar(Briefcase, t('tenantProfileTitle'), t('tenantProfileDescription'))}
      <div className="space-y-4 p-5 sm:p-6">
        <label className="flex cursor-pointer items-start gap-3 rounded-xl border border-gray-100 bg-slate-50/70 px-4 py-3">
          <input
            type="radio"
            name="tenant_profile"
            className="mt-1 h-4 w-4 border-gray-300 text-primary-700 focus:ring-primary-500"
            checked={profile === 'orgao'}
            onChange={() => setProfile('orgao')}
          />
          <span>
            <span className="block text-sm font-semibold text-gray-900">{t('tenantProfileOrgao')}</span>
            <span className="mt-0.5 block text-xs text-gray-500">{t('tenantProfileOrgaoHint')}</span>
          </span>
        </label>
        <label className="flex cursor-pointer items-start gap-3 rounded-xl border border-gray-100 bg-slate-50/70 px-4 py-3">
          <input
            type="radio"
            name="tenant_profile"
            className="mt-1 h-4 w-4 border-gray-300 text-primary-700 focus:ring-primary-500"
            checked={profile === 'consultoria'}
            onChange={() => setProfile('consultoria')}
          />
          <span>
            <span className="block text-sm font-semibold text-gray-900">{t('tenantProfileConsultoria')}</span>
            <span className="mt-0.5 block text-xs text-gray-500">{t('tenantProfileConsultoriaHint')}</span>
          </span>
        </label>
        <button type="button" className="btn btn-primary" onClick={save} disabled={saving}>
          {saving ? t('tenantProfileSaving') : t('tenantProfileSave')}
        </button>
      </div>
    </div>
  );
}
